module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_7016.a2de04fd.png";